import { render } from "./SuggestionsManager.vue?vue&type=template&id=3ec92d87&scoped=true"
import script from "./SuggestionsManager.vue?vue&type=script&lang=js"
export * from "./SuggestionsManager.vue?vue&type=script&lang=js"

import "./SuggestionsManager.vue?vue&type=style&index=0&id=3ec92d87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec92d87"]])

export default __exports__